var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _mask7, _path11, _path12, _mask8, _path13, _path14, _mask9, _path15, _path16, _mask0, _path17, _path18, _mask1, _path19, _path20, _mask10, _path21, _path22, _mask11, _path23, _path24, _mask12, _path25, _path26, _mask13, _path27, _path28, _mask14, _path29, _path30, _circle, _path31;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelImg(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 5,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 1,
    width: 5,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3688 1.65427C12.9655 1.49149 12.551 1.35815 12.1284 1.2553L10 10L13.3688 1.65427Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3688 1.65427C12.9655 1.49149 12.551 1.35815 12.1284 1.2553L10 10L13.3688 1.65427Z",
    fill: "#86BB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3688 1.65427C12.9655 1.49149 12.551 1.35815 12.1284 1.2553L10 10L13.3688 1.65427Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-1-outside-1_350_1985)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 8,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 1,
    width: 8,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.63604C15.6474 2.91948 14.815 2.32909 13.9018 1.88976L10 10L16.364 3.63604Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.63604C15.6474 2.91948 14.815 2.32909 13.9018 1.88976L10 10L16.364 3.63604Z",
    fill: "#123051"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.364 3.63604C15.6474 2.91948 14.815 2.32909 13.9018 1.88976L10 10L16.364 3.63604Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-2-outside-2_350_1985)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 3,
    width: 9,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 3,
    width: 9,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 5.47123C17.4428 4.89626 17.0452 4.3602 16.5923 3.87285L10 10L17.7775 5.47123Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 5.47123C17.4428 4.89626 17.0452 4.3602 16.5923 3.87285L10 10L17.7775 5.47123Z",
    fill: "#F79A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 5.47123C17.4428 4.89626 17.0452 4.3602 16.5923 3.87285L10 10L17.7775 5.47123Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-3-outside-3_350_1985)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 5,
    width: 10,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1484 6.17859C18.0239 5.91304 17.8864 5.65373 17.7366 5.4016L10 10L18.1484 6.17859Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1484 6.17859C18.0239 5.91304 17.8864 5.65373 17.7366 5.4016L10 10L18.1484 6.17859Z",
    fill: "#86BB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1484 6.17859C18.0239 5.91304 17.8864 5.65373 17.7366 5.4016L10 10L18.1484 6.17859Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-4-outside-4_350_1985)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 10,
    height: 5,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 6,
    width: 10,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8734 8.4956C18.7344 7.67571 18.4824 6.87904 18.1247 6.12833L10 10L18.8734 8.4956Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8734 8.4956C18.7344 7.67571 18.4824 6.87904 18.1247 6.12833L10 10L18.8734 8.4956Z",
    fill: "#123051"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8734 8.4956C18.7344 7.67571 18.4824 6.87904 18.1247 6.12833L10 10L18.8734 8.4956Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-5-outside-5_350_1985)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-6_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 3,
    width: 8,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 3,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 3.90627C16.4499 3.71797 16.2687 3.53714 16.0801 3.36428L10 10L16.6232 3.90627Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 3.90627C16.4499 3.71797 16.2687 3.53714 16.0801 3.36428L10 10L16.6232 3.90627Z",
    fill: "#F32A00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 3.90627C16.4499 3.71797 16.2687 3.53714 16.0801 3.36428L10 10L16.6232 3.90627Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-6-outside-6_350_1985)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-7_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 4,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    width: 4,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1037 1.24932C11.5971 1.12752 11.0808 1.04995 10.5607 1.01748L10 10L12.1037 1.24932Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1037 1.24932C11.5971 1.12752 11.0808 1.04995 10.5607 1.01748L10 10L12.1037 1.24932Z",
    fill: "#F5CC3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1037 1.24932C11.5971 1.12752 11.0808 1.04995 10.5607 1.01748L10 10L12.1037 1.24932Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-7-outside-7_350_1985)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-8_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 1,
    width: 6,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 1,
    width: 6,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9284 1.9026C13.7392 1.81084 13.5469 1.72573 13.3518 1.64744L10 10L13.9284 1.9026Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9284 1.9026C13.7392 1.81084 13.5469 1.72573 13.3518 1.64744L10 10L13.9284 1.9026Z",
    fill: "#77CCCD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9284 1.9026C13.7392 1.81084 13.5469 1.72573 13.3518 1.64744L10 10L13.9284 1.9026Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-8-outside-8_350_1985)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-9_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 9,
    width: 9,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2,
    y: 9,
    width: 9,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94029 15.5822C4.18946 17.162 5.93243 18.2771 7.89032 18.7492L10 10L2.94029 15.5822Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94029 15.5822C4.18946 17.162 5.93243 18.2771 7.89032 18.7492L10 10L2.94029 15.5822Z",
    fill: "#99439D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94029 15.5822C4.18946 17.162 5.93243 18.2771 7.89032 18.7492L10 10L2.94029 15.5822Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-9-outside-9_350_1985)"
  })), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-10_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 4,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7,
    y: 9,
    width: 4,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69773 18.7005C8.46185 18.9027 9.24928 19.0034 10.0397 18.9999L10 10L7.69773 18.7005Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69773 18.7005C8.46185 18.9027 9.24928 19.0034 10.0397 18.9999L10 10L7.69773 18.7005Z",
    fill: "#86BB00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69773 18.7005C8.46185 18.9027 9.24928 19.0034 10.0397 18.9999L10 10L7.69773 18.7005Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-10-outside-10_350_1985)"
  })), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-11_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 11,
    height: 10,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 9,
    width: 11,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5463 18.6323C14.3331 18.1052 15.9124 17.0367 17.0661 15.574C18.2199 14.1114 18.8914 12.3267 18.9879 10.4663L10 10L12.5463 18.6323Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5463 18.6323C14.3331 18.1052 15.9124 17.0367 17.0661 15.574C18.2199 14.1114 18.8914 12.3267 18.9879 10.4663L10 10L12.5463 18.6323Z",
    fill: "#123051"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5463 18.6323C14.3331 18.1052 15.9124 17.0367 17.0661 15.574C18.2199 14.1114 18.8914 12.3267 18.9879 10.4663L10 10L12.5463 18.6323Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-11-outside-11_350_1985)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-outside-12_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 11,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 8,
    width: 11,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9795 10.6069C19.027 9.90407 18.9918 9.19814 18.8747 8.50355L10 10L18.9795 10.6069Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9795 10.6069C19.027 9.90407 18.9918 9.19814 18.8747 8.50355L10 10L18.9795 10.6069Z",
    fill: "#86BB00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9795 10.6069C19.027 9.90407 18.9918 9.19814 18.8747 8.50355L10 10L18.9795 10.6069Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-12-outside-12_350_1985)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-outside-13_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 4,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 9,
    width: 4,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19C10.8773 19 11.7498 18.8717 12.59 18.6193L10 10V19Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C10.8773 19 11.7498 18.8717 12.59 18.6193L10 10V19Z",
    fill: "#F32A00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C10.8773 19 11.7498 18.8717 12.59 18.6193L10 10V19Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-13-outside-13_350_1985)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-14_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 11,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 1.01587C8.84753 0.915558 7.16658 1.29213 5.68382 2.10249C4.20106 2.91286 2.97638 4.12428 2.14993 5.59814C1.32348 7.07199 0.928638 8.74874 1.01059 10.4365C1.09255 12.1243 1.64798 13.7549 2.61335 15.1417L10 10L10.5343 1.01587Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 1.01587C8.84753 0.915558 7.16658 1.29213 5.68382 2.10249C4.20106 2.91286 2.97638 4.12428 2.14993 5.59814C1.32348 7.07199 0.928638 8.74874 1.01059 10.4365C1.09255 12.1243 1.64798 13.7549 2.61335 15.1417L10 10L10.5343 1.01587Z",
    fill: "#9AD4D9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 1.01587C8.84753 0.915558 7.16658 1.29213 5.68382 2.10249C4.20106 2.91286 2.97638 4.12428 2.14993 5.59814C1.32348 7.07199 0.928638 8.74874 1.01059 10.4365C1.09255 12.1243 1.64798 13.7549 2.61335 15.1417L10 10L10.5343 1.01587Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-14-outside-14_350_1985)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-15_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 11,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 1.01587C9.15556 0.933877 7.77644 1.17031 6.50374 1.70686C5.23104 2.24341 4.09891 3.06568 3.195 4.11001C2.2911 5.15433 1.63968 6.39268 1.29119 7.72918C0.9427 9.06567 0.906488 10.4644 1.18536 11.8172L10 10L10.5343 1.01587Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 1.01587C9.15556 0.933877 7.77644 1.17031 6.50374 1.70686C5.23104 2.24341 4.09891 3.06568 3.195 4.11001C2.2911 5.15433 1.63968 6.39268 1.29119 7.72918C0.9427 9.06567 0.906488 10.4644 1.18536 11.8172L10 10L10.5343 1.01587Z",
    fill: "#AAABAD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 1.01587C9.15556 0.933877 7.77644 1.17031 6.50374 1.70686C5.23104 2.24341 4.09891 3.06568 3.195 4.11001C2.2911 5.15433 1.63968 6.39268 1.29119 7.72918C0.9427 9.06567 0.906488 10.4644 1.18536 11.8172L10 10L10.5343 1.01587Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-15-outside-15_350_1985)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-outside-16_350_1985",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 9,
    width: 9,
    height: 7,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2,
    y: 9,
    width: 9,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36761 14.7693C2.55994 15.0771 2.77072 15.373 2.99879 15.6554L10 10L2.36761 14.7693Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36761 14.7693C2.55994 15.0771 2.77072 15.373 2.99879 15.6554L10 10L2.36761 14.7693Z",
    fill: "#F5CC3B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36761 14.7693C2.55994 15.0771 2.77072 15.373 2.99879 15.6554L10 10L2.36761 14.7693Z",
    stroke: "white",
    strokeWidth: 0.161616,
    mask: "url(#path-16-outside-16_350_1985)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.0003,
    r: 6.59307,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.484848
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.319 10.0001C18.319 14.5945 14.5945 18.319 10.0001 18.319C5.40566 18.319 1.68115 14.5945 1.68115 10.0001C1.68115 5.40566 5.40566 1.68115 10.0001 1.68115C14.5945 1.68115 18.319 5.40566 18.319 10.0001ZM3.51406 10.0001C3.51406 13.5822 6.41794 16.4861 10.0001 16.4861C13.5822 16.4861 16.4861 13.5822 16.4861 10.0001C16.4861 6.41794 13.5822 3.51406 10.0001 3.51406C6.41794 3.51406 3.51406 6.41794 3.51406 10.0001Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelImg);
export default __webpack_public_path__ + "static/media/wheel_img.46897efcae4ed9c462f67b8b3e833ca6.svg";
export { ForwardRef as ReactComponent };